import { useAppSelector } from "store/store";
import { Icon } from "./Icon/Icon";

interface IconsProps {
    xRatio: number;
    yRatio: number;
}

export const Icons = ({xRatio, yRatio}: IconsProps) =>{
    const icons = useAppSelector((state) => state.memeGenerator.meme?.icons) || [];
    return (
        <>
            {icons.map((icon) => (
                <Icon key={icon.id} icon={icon} xRatio={xRatio} yRatio={yRatio} />
            ))}
        </>
    );
}
